__turbopack_context__.v({
  "icon": "styles-module-scss-module__pmHAfq__icon",
  "start": "styles-module-scss-module__pmHAfq__start",
});
